<template>
    <dashboard v-if="user">
        <heading>
            <h1 slot="title">{{ user.first_name }} {{ user.last_name }}</h1>

            <app-tag v-if="!user.active" 
                     slot="tag" 
                     type="danger" 
                     size="small">Not Activated</app-tag>

            <template slot="buttons">
                <app-button v-if="!user.active" @click="resendInvite">Resend Invite</app-button>
            </template>
        </heading>
        <row>
            <link-list :routes="routes">
                <template slot-scope="{ route }">{{ route.title }}</template>
            </link-list>
            <router-view :user-id="id" :user="user" />
        </row>
    </dashboard>
</template>

<script>
import { get, comb, first } from '@/utilities'
import User from '@/store/models/User'

export default {
    name: 'page-users-detail',
    props: {
        id: Number
    },
    head: {
        title() {
            return {
                inner: comb(
                    'User',
                    '-',
                    get(this, 'user.first_name'),
                    get(this, 'user.last_name')
                )
            }
        }
    },
    data() {
        return {
            routes: [
                {
                    title: 'User Information',
                    name: 'users.detail.information'
                },
                {
                    title: 'Access',
                    name: 'users.detail.access',
                    subroutes: [
                        {
                            title: 'Courses',
                            name: 'users.detail.access.courses'
                        },
                        {
                            title: 'Events',
                            name: 'users.detail.access.events'
                        },
                        {
                            title: 'Teams',
                            name: 'users.detail.access.teams'
                        },
                        {
                            title: 'Student',
                            name: 'users.detail.access.students'
                        }
                    ]
                },
                {
                    title: 'Security / Password',
                    name: 'users.detail.security'
                },
                {
                    title: 'Notifications',
                    name: 'users.detail.notifications'
                }
            ]
        }
    },
    computed: {
        user() { 
            return User.query()
                .withAll()
                .find(this.id) 
        }
    },
    mounted() {
        this.getUser(this.id)
    },
    methods: {
        getUser(id) {
            User.$fetchOne({ id })
                .then(() => {
                    this.$emit('updateHead')
                })
                .catch(() => {
                    this.$router.push({ name: 'users' })
                })
        },
        resendInvite() {
            User.$mutate({
                graphql: 'invite',
                variables: this.user
            })
                .then(() => {
                    this.isSaving = false
                    this.$notify({
                        title: 'Success',
                        message: 'A new invitation has been sent to the user!',
                        type: 'success',
                        offset: 75,
                        duration: 2000
                    })
                })
                .catch( (errors) => {
                    this.isSaving = false
                    this.error = get(first(errors), 'message', null)
                })
        }
    },
    watch: {
        id(newVal) {
            this.getUser(newVal)
        }
    }
}
</script>

<style lang="stylus"></style>
